import React from "react";

export const Debug = ({ theVar }: any) => {
  return (
    <pre style={{ fontSize: "14px", background: "#f1f1f1", padding: "1em" }}>
      <b>
        <u>type: {typeof theVar}</u>
      </b>
      <br />
      {JSON.stringify(theVar, null, 2)}
    </pre>
  );
};
